











import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import SecureElementComponent from "@/components/zorgID/SecureElementComponent.vue";
import { setTimeout } from "timers";

@Component({
  components: {
    SecureElementComponent,
  },
})
export default class Info extends Vue {
  private sessionId: string = "";

  private mounted() {
    var me = this;
    setTimeout(() => {
      me.sessionId = SecurityService.getInstance().sessionId;
    }, 1000);
  }
}
